<div class="">
  <!-- Dark only; <html class="dark"> also covers overlays portaled to <body> -->
  <div class="app dark">
    <router-outlet></router-outlet>
    <!-- One live region for toasts, present before the first toast is written -->
    <bk-toast-outlet />
  </div>
</div>
